var map = {
	"./icons/exchange.svg": 9143,
	"./icons/iconbox_bg.svg": 12,
	"./icons/logout.svg": 946,
	"./icons/question.svg": 476,
	"./icons/warning.svg": 2428,
	"./logos/240Tech.svg": 6604,
	"./logos/240Tech_Logo.png": 5621,
	"./logos/Logo-thin.png": 6358,
	"./logos/favicon.ico": 1315,
	"./logos/logo-2.png": 5101,
	"./logos/logo-launcher-1.png": 1145,
	"./logos/logo-launcher-2.png": 6002,
	"./logos/logo.png": 1400,
	"./misc/bg_icon.svg": 5451,
	"./misc/clouds.png": 8033,
	"./misc/iconbox_bg-white.png": 8727,
	"./misc/iconbox_bg.png": 4663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8257;